import { render, staticRenderFns } from "./Inep.vue?vue&type=template&id=22f1f590&scoped=true&lang=pug&"
import script from "./Inep.vue?vue&type=script&lang=ts&"
export * from "./Inep.vue?vue&type=script&lang=ts&"
import style0 from "./Inep.vue?vue&type=style&index=0&id=22f1f590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1f590",
  null
  
)

export default component.exports